import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SabloaneComponent } from './sabloane.component';
import { AddSabloaneComponent } from './add-sabloane/add-sabloane.component';
import { EditSabloaneComponent } from './edit-sabloane/edit-sabloane.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SabloaneComponent,
    AddSabloaneComponent,
    EditSabloaneComponent,
  ],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
  exports: [SabloaneComponent],
})
export class SabloaneModule {}
